module.exports = __webpack_public_path__ + "img/bookclub-vid.88daf011.gif";